import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CampaignsService } from 'src/app/services/campaigns.service';
import { GlobalService } from 'src/app/services/common/global.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { AlertService } from 'src/app/services/common/alert.service';
import { UtilityService } from 'src/app/services/utility.service';
import { ConstantTypeKey } from 'src/app/services/common/constant.service';
import { ResourceService } from 'src/app/services/common/resource.service';

@Component({
  selector: 'app-coupon-generate',
  templateUrl: './coupon-generate.component.html',
  styleUrls: ['./coupon-generate.component.scss']
})
export class CouponGenerateComponent implements OnInit {

  code: any = "XXXXXXXXXXXX";
  qrCodeImage: any = "";
  offerTypeList!: any[];

  campaignDetail: any;
  showBarcode = false;

  offerTypeTitle: any;
  location: any;
  resource: any = {};

  constructor(private campaignsService: CampaignsService,
    private clipboard: Clipboard,
    private utilityService: UtilityService,
    private alertService: AlertService,
    private resourceService: ResourceService,
    public dialogRef: MatDialogRef<CouponGenerateComponent>,
    @Inject(MAT_DIALOG_DATA) public campaignData: any) { }

  async ngOnInit() {
    this.loadResoruce();
    this.resourceService.languageSubject.subscribe(response => {
      this.resource = response;
    });
    await this.getConstantList();
    this.campaignsService.detail(this.campaignData.campaignId).subscribe(async (response: any) => {
      if (response) {
        this.campaignDetail = response.data;

        if (this.campaignDetail.country) {
          this.location = this.campaignDetail.country;
        }

        if (this.campaignDetail.state) {
          this.location += ", " + this.campaignDetail.state;
        }

        if (this.campaignDetail.city) {
          this.location += ", " + this.campaignDetail.city;
        }


        if (this.offerTypeList) {
          var offerType = this.offerTypeList.find(x => x.code == this.campaignDetail.offerType);
          if (offerType) {
            if (this.campaignDetail.offerType == "BUYGET") {
              this.offerTypeTitle = "Buy " + this.campaignDetail.mainProductCount + " Get " + this.campaignDetail.freeProductCount;
            }
const slab = this.campaignDetail?.invoiceAmountSlab;
let discount = 0;

if (Array.isArray(slab) && slab.length) {
  const lastSlab = slab[slab.length - 1];

  if (this.campaignDetail.offerType === 'FLAT') {
    discount = lastSlab.couponValue;
  }
  else if (this.campaignDetail.offerType === 'DISCOUNT') {
    discount = lastSlab.discountPercentage;
  }

  if (!discount && this.campaignData?.discount) {
    discount = Number(this.campaignData.discount);
  }

  if (this.campaignDetail.offerType === 'BUYGET') {
    this.offerTypeTitle =
      `Buy ${this.campaignDetail.mainProductCount} Get ${this.campaignDetail.freeProductCount}`;
  }
  else if (this.campaignDetail.offerType === 'FLAT') {
    this.offerTypeTitle =
      `Flat ${this.campaignDetail.currencySymbol}${this.formateNumber(discount, false)}`;
      // `Flat ${this.campaignDetail.currencySymbol}${this.formateNumber(discount, true)}`;
  }
  else if (this.campaignDetail.offerType === 'DISCOUNT') {
    this.offerTypeTitle =
  `Discount ${this.formateNumber(discount, false)}%`;
      // `Discount ${this.formateNumber(discount, true)}%`;
  }
  else {
    this.offerTypeTitle =
      this.offerTypeList.find(x => x.code == this.campaignDetail.offerType)?.name;
  }
}
            
  // else if (this.campaignDetail.offerType == "FLAT") {
  //             this.offerTypeTitle = "Flat " + this.campaignDetail.currencySymbol + this.formateNumber(this.campaignDetail.couponValue, true);
  //           }
  //           else if (this.campaignDetail.offerType == "FREESAM") {
  //             this.offerTypeTitle = this.offerTypeList.find(x => x.code == this.campaignDetail.offerType).name;
  //           }
  //           else if (this.campaignDetail.offerType == "GIFTVC") {
  //             this.offerTypeTitle = this.offerTypeList.find(x => x.code == this.campaignDetail.offerType).name + ' ' + this.campaignDetail.currencySymbol + this.formateNumber(this.campaignDetail.couponValue, true);
  //           }
  //           else if (this.campaignDetail.offerType == "DISCOUNT") {
  //             this.offerTypeTitle = "Discount " + this.formateNumber(this.campaignDetail.couponValue, true) + "%";
  //           }
            else {
              this.offerTypeTitle = this.offerTypeList.find(x => x.code == this.campaignDetail.offerType).name;
            }
          }
        }
      }
    });
    this.getCouponGenerate();
  }

  loadResoruce() {
    this.resourceService.loadResoruce().subscribe(
      response => {
        this.resource = response;
      });
  }


  async getConstantList() {
    await this.utilityService.getConstantList(ConstantTypeKey.OfferType).toPromise().then((response: any) => {
      if (response.success) {
        this.offerTypeList = response.data;
      }
    })
  }

  onClickCopyCode() {
    this.clipboard.copy(this.code);
    this.dialogRef.close();
    this.alertService.showSuccess("Code Copied");
  }

  getCouponGenerate() {
    if (this.campaignData.isGuest) {
      this.campaignsService.guestCouponGenerate(this.campaignData.campaignId).subscribe((response: any) => {
        if (response.success) {
          this.code = response.data.code;
          this.qrCodeImage = response.data.qrcode;
        } else {
          this.alertService.showError(response.message);
          this.dialogRef.close();
        }
      })
    } else {
      this.campaignsService.couponGenerate(this.campaignData.campaignId).subscribe((response: any) => {
        if (response.success) {
          this.code = response.data.code;
          this.qrCodeImage = response.data.qrcode;
        } else {
          this.alertService.showError(response.message);
          this.dialogRef.close({ showError: true });
        }
      });
    }
  }

  onClickCode() {
    this.showBarcode = this.showBarcode ? false : true;
  }

  // formateNumber(n: any, decimal: boolean = true) {
  //   let parts = (+n).toFixed(2).split(".");
  //   let num = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (+parts[1] ? "." + parts[1] : decimal ? ".00" : "");
  //   return num;
  // }
formateNumber(n: any, showDecimal: boolean = false) {
  const num = Number(n);

  if (isNaN(num)) return '0';

  const hasDecimal = num % 1 !== 0;

  return new Intl.NumberFormat('en-IN', {
    minimumFractionDigits: showDecimal ? 2 : 0,
    maximumFractionDigits: hasDecimal || showDecimal ? 2 : 0
  }).format(num);
}
}
